import * as Slider from '@radix-ui/react-slider'
import styled, { css } from 'styled-components'

import { SliderIcon } from '@root/shared/ui-kit'

import { TradingSliderTicks } from './trading-slider-ticks'

import type { TradeType } from '@root/entities/trade-type'

export type TradingSliderProps = {
  step: number
  value: number
  ticks: [number, number, number, number, number]
  onChange: (value: Array<number>) => void
  type: TradeType.SwapDirection
}

export const TradingSlider: React.FC<TradingSliderProps> = ({
  step,
  value,
  onChange,
  type,
  ticks,
}) => {
  const percentageNumber = Number(value) || 0
  const min = ticks[0]
  const max = ticks[4]

  return (
    <Root data-type={type}>
      <SliderRoot
        value={[percentageNumber]}
        min={min}
        max={max}
        step={step}
        onValueChange={onChange}
      >
        <SliderTrack>
          <SliderRange />
        </SliderTrack>
        <SliderThumb>
          <SliderIcon />
        </SliderThumb>
      </SliderRoot>
      <TradingSliderTicks
        type={type}
        value={percentageNumber}
        ticks={ticks}
        onClick={(value) => onChange([value])}
        css={css`
          margin-top: 4px;
        `}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  align-items: center;

  gap: 6px;

  &[data-type='buy'] {
    --slider-track: rgba(var(--upAccent-7-rgb), 0.3);
    --slider-range: var(--upAccent-9);
    --slider-thumb: var(--upAccent-9);
    --slider-active: var(--upAccent-9);
  }

  &[data-type='sell'] {
    --slider-track: rgba(var(--downAccent-7-rgb), 0.3);
    --slider-range: var(--downAccent-9);
    --slider-thumb: var(--downAccent-9);
    --slider-active: var(--downAccent-9);
  }
`

const SliderRoot = styled(Slider.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  height: 20px;
  padding-inline: 2px;

  cursor: pointer;
`

const SliderTrack = styled(Slider.Track)`
  background-color: var(--slider-track);
  box-shadow: inset 0 0 0 1px rgb(0 0 0 / 4%);

  position: relative;
  flex-grow: 1;
  border-radius: 9999px;
  height: 4px;
`

const SliderRange = styled(Slider.Range)`
  background-color: var(--slider-range);

  position: absolute;
  border-radius: 9999px;
  height: 100%;
`

const SliderThumb = styled(Slider.Thumb)`
  color: var(--slider-thumb);

  display: block;
  padding-top: 7px;
  transition: all 150ms;
  cursor: pointer;

  &:hover {
    color: var(--slider-active);
    outline: none;
    transform: scale(1.2);
  }
  &:focus {
    color: var(--slider-active);
  }
`
